import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import type { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";

import { LeadScoreAddRuleCombobox } from "./LeadScoreAddRuleCombobox";

type Props = {
    onAddRule: (priority: LeadPriorityScore) => void;
};

export const LeadScoreFilterEmptyState = ({ onAddRule }: Props) => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="4px"
            alignItems="flex-start"
            data-automation="lead-score-filter-empty-state"
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[300]}
            >
                {translate(leadsSearchFiltersI18nKeys.leadScoresEmptyDescription())}
            </Text>
            <LeadScoreAddRuleCombobox onSelectPriority={onAddRule} />
        </Stack>
    );
};
